import { useState, useRef, useEffect } from "react";
import { useTheme, ACCENTS } from "@/context/ThemeContext";
import { Palette, Check } from "lucide-react";

export default function AccentPicker({ testId = "accent-picker" }) {
  const { accent, setAccent } = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  const active = ACCENTS.find((a) => a.id === accent) || ACCENTS[0];

  return (
    <div ref={ref} className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-9 h-9 border border-brand-gold/30 rounded-lg flex items-center justify-center hover:bg-brand-gold/10 transition-colors"
        title={`Accent color · ${active.label}`}
        aria-label="Change accent color"
        data-testid={testId}
      >
        <Palette className="w-4 h-4" style={{ color: active.hex }} />
      </button>
      {open && (
        <div className="absolute right-0 top-11 z-50 w-56 rounded-xl border border-brand-gold/25 bg-card shadow-2xl shadow-black/40 overflow-hidden" data-testid={`${testId}-menu`}>
          <div className="px-3 pt-3 pb-2 text-[10px] uppercase tracking-[0.3em] font-black text-muted-foreground">Accent color</div>
          <div className="px-2 pb-2">
            {ACCENTS.map((a) => (
              <button
                key={a.id}
                type="button"
                onClick={() => { setAccent(a.id); setOpen(false); }}
                className={`w-full flex items-center gap-3 px-2 py-2 rounded-lg text-left hover:bg-secondary/70 transition-colors ${
                  accent === a.id ? "bg-secondary/70" : ""
                }`}
                data-testid={`${testId}-opt-${a.id}`}
              >
                <span className="w-5 h-5 rounded-full ring-2 ring-white/20" style={{ background: a.hex }} />
                <span className="flex-1 text-sm font-bold">{a.label}</span>
                {accent === a.id && <Check className="w-4 h-4" style={{ color: a.hex }} strokeWidth={3} />}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
